import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userData = useSelector((state) => state.appSlice.userData);

  if (!userData) {
    return <Navigate to="/login" />;
  }

  if (userData && !userData.phone_number) {
    return <Navigate to="/complete-profile" />;
  }

  return children;
};

export default ProtectedRoute;
